import React from "react";
import PersonSVG from "images/Person.svg";

export const Empty = ({ classes, upcoming, emptyView }) => {
  return (
    <div className={classes.emptyTableView}>
      <div className={classes.divStyle}>
        <img src={PersonSVG} />
        <div>
          {emptyView
            ? "No data to show for the selected filters"
            : upcoming
            ? "No person has been RSVPed yet"
            : "No person has been attended yet"}
        </div>
      </div>
    </div>
  );
};
